export default {
  title: '生産バッチ',
  addBatch: '生産バッチを追加',
  batchInfo: 'バッチ情報',
  batchInfoPlaceholder: 'バッチIDまたはバッチ名を入力してください',
  productInfo: '商品情報',
  productInfoPlaceholder: '商品名を入力してください',
  productNoLabel: '商品番号：',
  id: 'ID',
  batchName: 'バッチ名',
  createTime: '作成日時',
  batchNameLabel: 'バッチ名',
  batchNamePlaceholder: 'バッチ名を入力してください',
  batchNameRequired: 'バッチ名を入力してください',
  batchNameMax: '最大30文字',
  relatedProduct: '関連商品',
  selectSku: 'SKUを選択',
  skuPlaceholder: 'SKU',
  productionDate: '生産日',
  productionDatePlaceholder: '生産日を選択してください',
  productionDateRequired: '生産日を選択してください',
  shelfLife: '賞味期限',
  shelfLifeRequired: '賞味期限タイプを選択してください',
  validityMode: '有効期間モード',
  validityModeRequired: '有効期間モードを選択してください',
  validityModePlaceholder: '有効期間モードを選択してください',
  validityNum: '有効期間',
  validityNumRequired: '有効期間を入力してください',
  validDays: '有効日数',
  validMonths: '有効月数',
  validDate: '有効期限',
  validityYears: '年単位',
  validityLongTerm: '長期有効',
  validDaysPlaceholder: '有効日数を入力してください',
  validDaysRequired: '有効日数を入力してください',
  validMonthsPlaceholder: '有効月数を入力してください',
  validMonthsRequired: '有効月数を入力してください',
  validDatePlaceholder: '有効期限を選択してください',
  validDateRequired: '有効期限を選択してください',
  validityYearsPlaceholder: '有効年数を入力してください',
  relatedProductRequired: '関連商品を選択してください',
  remark: '備考',
  remarkPlaceholder: '備考を入力してください',
  factory: '生産工場',
  inspectionReport: '検査報告書',
  inspectionReportTip: '検査報告書の画像をアップロードしてください',
  selectProductTitle: '商品を選択',
  productName: '商品名',
  productNamePlaceholder: '商品名を入力してください',
  spec: '仕様',
  category: 'カテゴリ',
  retailPrice: '小売価格',
  select: '選択',
};
